import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import curebay from '../../assets/images/CBLogo.png';
import apiService from '../../services/apiservice';

const FinanceApproval = () => {
  const location = useLocation();
  const [approveUrl, setApproveUrl] = useState('');
  const [rejectUrl, setRejectUrl] = useState('');
  const [approvalMessage, setApprovalMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  
  const enqId = queryParams.get('Id');
  const patientName = queryParams.get('patientName');
  const typeofSurgery = queryParams.get('typeofSurgery');
  const patientId = queryParams.get('patientId');
  const surgeryConfirmDate = queryParams.get('surgeryConfirmDate');
  const gross = queryParams.get('gross');
  const mci = queryParams.get('mci');
  const netsale = queryParams.get('netSaleAmt');

  useEffect(() => {
    setApprovalMessage('');
    if (!enqId) return;
    
    try {
      const encryptData1 = btoa(`${enqId}|A|F`);
      const encryptData2 = btoa(`${enqId}|R|F`);
      setApproveUrl(encryptData1);
      setRejectUrl(encryptData2);
    } catch (error) {
      console.error('Error encoding data:', error);
    }
  }, [enqId]);

  const handleApproval = useCallback(async (action) => {
    if (isLoading) return;
    
    setIsLoading(true);
    try {
      const url = action === 'A' ? approveUrl : rejectUrl;
      const payload = { parameter1: url };
      const response = await apiService.financeApproval(payload);
      setApprovalMessage(response?.data?.successObject?.message || 'Action completed');
    } catch (error) {
      console.error('Error in approval process:', error);
      setApprovalMessage('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  }, [approveUrl, rejectUrl, isLoading]);

  if (approvalMessage) {
    return (
      <div className="flex justify-center items-center w-full h-screen">
        <h1 className='text-xl font-bold'>{approvalMessage}</h1>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center w-full h-screen">
      <div className="container">
        <div className="flex justify-center items-center h-full">
          <div className="w-full max-w-md mx-auto">
            <div className="mb-4 flex justify-start">
              <img src={curebay} alt="Curebay Logo" />
            </div>
            <div className="w-full">
              <p>Hi,</p>
              <p>Required your approval for below patient billing.</p>
              <ul className='mt-4'>
                <li><strong>Patient ID:</strong> {patientId || 'N/A'}</li>
                <li><strong>Patient Name:</strong> {patientName || 'N/A'}</li>
                <li><strong>Surgery Type:</strong> {typeofSurgery || 'N/A'}</li>
                <li><strong>Surgery Confirmed Date:</strong> {surgeryConfirmDate || 'N/A'}</li>
                <li><strong>GROSS:</strong> {gross || 'N/A'}</li>
                <li><strong>MCI:</strong> {mci || 'N/A'}</li>
                <li><strong>CureBay Share:</strong> {netsale || 'N/A'}</li>
              </ul>
            </div>
            <div className="flex items-center gap-4 mt-4">
              <button 
                className={`btn bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={() => handleApproval('A')}
                disabled={isLoading}
              >
                {isLoading ? 'Processing...' : 'Billing Approve'}
              </button>
              <button 
                className={`btn bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={() => handleApproval('R')}
                disabled={isLoading}
              >
                {isLoading ? 'Processing...' : 'Billing Reject'}
              </button>
            </div>
            <p className="mt-4">Thanks,<br />CureBay Support</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinanceApproval;